module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logging-in"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding": "20px 0px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "margin": "20px 0 20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('H1', {
    staticStyle: {
      "color": "var(--theme-primary)"
    }
  }, [_vm._v("Signing in ...")])], 1)]), _vm._v(" "), _c('spinner', {
    attrs: {
      "spinnerOn": true
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40e44573", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40e44573"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/LoggingIn.vue
// module id = 695
// module chunks = 1